var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.$style.svg,attrs:{"height":"50","width":"50","viewBox":"0 0 50 50"}},[_c('circle',{class:_vm.$style.circle,attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"4"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2617f985","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/BaseLoading.vue
// module id = KMJ6
// module chunks = 4